<template>
<div>

<!-- Conditional rendering based on whether the browser is WeChat or not -->
<div v-if="isWeChat">
  <div style='position:relative;padding-top:100px;color:#333;font-size: 22px;text-align: center;'>
    <i style='position: absolute;top: 10px;right: 10px;font-size: 100px' class='iconfont icon-jiantou'></i>
    <p style="font-weight: 600;">请点击屏幕右上角 [ ··· ]</p>
    <p>在 <i style='font-size: 60px;color: #1487F0' class='iconfont icon-browser'></i> 浏览器打开</p>
  </div>
</div>

<!-- Original Vue component content if not WeChat -->
<div v-else>
  <section class="hero is-primary" id="head-section">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h2 class="title">下载手簿</h2>
      </div>
    </div>
  </section>

  <div class="card">
    <div class="card-content">
      <p class="content" style="text-align:center;">
        {{ downloadName }}.zip
      </p>
      <!-- <p class="subtitle">
        Excel 手簿
      </p> -->
    </div>
    <footer class="card-footer">
      <a :href="downloadUrl" class="card-footer-item">下载</a>
    </footer>
  </div>

</div>

</div>
</template>

<script>
import { base64d4url } from '@/utils'

export default {
  props: ['dl_name', 'dl_id'],
  // methods: {
  // }
  data () {
    return {
      isWeChat: false, // Default value
      downloadName: base64d4url(this.$route.params.dl_name),
      downloadUrl: base64d4url(this.$route.params.dl_id)
    }
  },
  mounted () {
    this.detectBrowser()
  },
  methods: {
    detectBrowser () {
      var u = navigator.userAgent
      var isWeChat = u.indexOf('MicroMessenger') > 0 // Check if the browser is WeChat
      this.isWeChat = isWeChat
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Download.vue